import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Extend dayjs with required plugins
dayjs.extend(utc)
dayjs.extend(timezone)

// Colombian timezone constant
const COLOMBIAN_TIMEZONE = 'America/Bogota'

/**
 * Converts a Dayjs object to a JavaScript Date in Colombian timezone
 * This ensures the date/time is saved exactly as shown in the UI
 *
 * @param date - Dayjs object from the date picker
 * @returns JavaScript Date object in Colombian timezone
 */
export const toColombianDate = (date: Dayjs | null): Date | string => {
  if (!date) return ''

  // Convert to Colombian timezone and then to Date object
  return dayjs(date).tz(COLOMBIAN_TIMEZONE).toDate()
}

/**
 * Gets the start of today in Colombian timezone
 * Used for filtering events that are today or later
 *
 * @returns JavaScript Date object representing start of today in Colombian timezone
 */
export const getColombianStartOfToday = (): Date => {
  return dayjs().tz(COLOMBIAN_TIMEZONE).startOf('day').toDate()
}

/**
 * Converts a Date or string to Dayjs in Colombian timezone
 * Used when loading dates from the database
 *
 * @param date - Date from database
 * @returns Dayjs object in Colombian timezone
 */
export const fromColombianDate = (date: Date | string): Dayjs => {
  return dayjs(date).tz(COLOMBIAN_TIMEZONE)
}
